'use strict';

/**
 * thumb
 */
export const thumb = (() => {
    const $thumb = $('.js-thumb');
    const $carousel = $('.js-carousel');
    const $frt = $('.js-frt-ttl');

    /**
     * init
     */
    const init = () => {
        $thumb.each((index, element) => {
            const $this = $(element);

            $this.on('click', event => {
                if ($this.hasClass('is-hide')) {
                    stop($this);

                    if ($this.hasClass('js-frt-trg')) {
                        $frt.removeClass('is-hide');
                    }
                } else {
                    if ($this.parents('.slick-current').length > 0) {
                        play($this);

                        if ($this.hasClass('js-frt-trg')) {
                            $frt.addClass('is-hide');
                        }
                    } else if ($this.hasClass('js-thumb-simple')) {
                        play($this);
                    }
                }
            });
        });
    };

    /**
     * play
     */
    const play = $element => {
        $element.addClass('is-hide');
        const $video = $element.next('.player');
        $video[0].contentWindow.postMessage('{"event": "command", "func": "playVideo", "args": ""}', '*');
        $video.addClass('is-play');
    };

    /**
     * stop
     */
    const stop = $element => {
        $element.removeClass('is-hide');
        const $video = $element.next('.player');
        $video[0].contentWindow.postMessage('{"event": "command", "func": "stopVideo", "args": ""}', '*');
        $video.removeClass('is-play');
    };

    // public
    return {
        init: init
    };
})();
